export const OWNERSHIP_TYPE_TRANSLATE = {
  own: 'Собственник',
  rent: 'Аренда',
  leasing: 'Лизинг',
  subcontracting: 'Субподряд',
};
